;(function () {
	const langs = document.querySelector( '.menu-bar__languages' );
	const activeClass = 'languages__language--active';

	if ( ! langs ) {
		return;
	}

	langs.addEventListener( 'click', e => {
		e.preventDefault();
		langs.querySelectorAll( '.languages__language' ).forEach( elem => {
			elem.classList.remove( activeClass );
		});
		e.target.parentElement.classList.add( activeClass );
	});
}());
